import React, { useState, useCallback } from 'react';
import './styles/theme.css';
import Header from './components/Header';
import ModeSelector from './components/ModeSelector';
import Sidebar from './components/Sidebar';
import WorkflowBar from './components/WorkflowBar';
import Chat from './components/Chat';
import { AGENT_MODULES, BURGER_MODULES } from './data/modules';

export default function App() {
  // ── STATE ──
  const [lang, setLang] = useState('nl');
  const [mode, setMode] = useState(null);         // null | 'agent' | 'burger'
  const [activeModule, setActiveModule] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [ttsEnabled, setTtsEnabled] = useState(false);
  const [messages, setMessages] = useState([]);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Get current module name for display
  const allModules = { ...AGENT_MODULES, ...BURGER_MODULES };
  const moduleName = activeModule ? (allModules[activeModule]?.[lang] || '') : '';

  // ── HANDLERS ──
  const handleSelectMode = useCallback((selectedMode) => {
    setMode(selectedMode);
    setActiveModule(null);
    setMessages([]);
    setCurrentStep(1);
  }, []);

  const handleSelectModule = useCallback((moduleKey) => {
    setActiveModule(moduleKey);
    setCurrentStep(1);
    // Messages are set by Chat component's useEffect
  }, []);

  const handleSwitchMode = useCallback(() => {
    setMode(prev => prev === 'agent' ? 'burger' : 'agent');
    setActiveModule(null);
    setMessages([]);
    setCurrentStep(1);
  }, []);

  // ── RENDER: Mode Selector ──
  if (!mode) {
    return <ModeSelector lang={lang} onSelectMode={handleSelectMode} />;
  }

  // ── RENDER: Main App ──
  return (
    <div className={`app-layout${mode === 'burger' ? ' burger-mode' : ''}`}>
      {/* Sidebar */}
      <Sidebar
        mode={mode}
        lang={lang}
        activeModule={activeModule}
        onSelectModule={handleSelectModule}
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(prev => !prev)}
        onSwitchMode={handleSwitchMode}
      />

      {/* Main Content */}
      <div className="main-content">
        {/* Header */}
        <Header
          lang={lang}
          setLang={setLang}
          ttsEnabled={ttsEnabled}
          setTtsEnabled={setTtsEnabled}
          messages={messages}
          moduleName={moduleName}
          onMobileMenu={() => {}}
        />

        {/* Workflow Bar (only for active module with workflow) */}
        {activeModule && (
          <WorkflowBar
            module={activeModule}
            currentStep={currentStep}
            lang={lang}
          />
        )}

        {/* Chat */}
        <Chat
          mode={mode}
          module={activeModule}
          lang={lang}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          ttsEnabled={ttsEnabled}
          messages={messages}
          setMessages={setMessages}
        />
      </div>
    </div>
  );
}
